/**
 * Vas Service Management Platform
 * VAS Service Managment Api
 *
 * OpenAPI spec version: v1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateVasServicWithServiceTypeDetailsDto } from '../model/createVasServicWithServiceTypeDetailsDto';
import { EventServiceModel } from '../model/eventServiceModel';
import { ModelSelectedDto } from '../model/modelSelectedDto';
import { PaginatedModelOfServiceDetailsModelOfObject } from '../model/paginatedModelOfServiceDetailsModelOfObject';
import { ProblemDetails } from '../model/problemDetails';
import { ServiceDetailsModelOfObject } from '../model/serviceDetailsModelOfObject';
import { ServiceProviderServicesDto } from '../model/serviceProviderServicesDto';
import { VasServiceResponseDto } from '../model/vasServiceResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VasServiceService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param model
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceCreateVasServiceByType(model: CreateVasServicWithServiceTypeDetailsDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public vasServiceCreateVasServiceByType(model: CreateVasServicWithServiceTypeDetailsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public vasServiceCreateVasServiceByType(model: CreateVasServicWithServiceTypeDetailsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public vasServiceCreateVasServiceByType(model: CreateVasServicWithServiceTypeDetailsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling vasServiceCreateVasServiceByType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/VasService/createvasserviceprocess`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param stringifiedGuidId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceDeleteService(stringifiedGuidId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public vasServiceDeleteService(stringifiedGuidId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public vasServiceDeleteService(stringifiedGuidId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public vasServiceDeleteService(stringifiedGuidId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (stringifiedGuidId !== undefined && stringifiedGuidId !== null) {
            queryParameters = queryParameters.set('stringifiedGuidId', <any>stringifiedGuidId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<string>(`${this.basePath}/api/VasService/DeleteService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param model
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceEventServiceFullDetailUpdate(model: EventServiceModel, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public vasServiceEventServiceFullDetailUpdate(model: EventServiceModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public vasServiceEventServiceFullDetailUpdate(model: EventServiceModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public vasServiceEventServiceFullDetailUpdate(model: EventServiceModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling vasServiceEventServiceFullDetailUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put(`${this.basePath}/api/VasService/EventServiceFullDetailUpdate`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param shortCode
     * @param keynumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceExistingShortcodeKeyNumber(shortCode?: string, keynumber?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public vasServiceExistingShortcodeKeyNumber(shortCode?: string, keynumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public vasServiceExistingShortcodeKeyNumber(shortCode?: string, keynumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public vasServiceExistingShortcodeKeyNumber(shortCode?: string, keynumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (keynumber !== undefined && keynumber !== null) {
            queryParameters = queryParameters.set('keynumber', <any>keynumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/VasService/ExistingShortcodeKeyNumber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceproviderId
     * @param searchword
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetAllService(serviceproviderId?: string, searchword?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfServiceDetailsModelOfObject>;
    public vasServiceGetAllService(serviceproviderId?: string, searchword?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfServiceDetailsModelOfObject>>;
    public vasServiceGetAllService(serviceproviderId?: string, searchword?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfServiceDetailsModelOfObject>>;
    public vasServiceGetAllService(serviceproviderId?: string, searchword?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceproviderId !== undefined && serviceproviderId !== null) {
            queryParameters = queryParameters.set('serviceproviderId', <any>serviceproviderId);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfServiceDetailsModelOfObject>(`${this.basePath}/api/VasService/getallservice`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceproviderId
     * @param industryId
     * @param categoryId
     * @param serviceCode
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetAllServiceByParameters(serviceproviderId?: string, industryId?: string, categoryId?: number, serviceCode?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceDetailsModelOfObject>>;
    public vasServiceGetAllServiceByParameters(serviceproviderId?: string, industryId?: string, categoryId?: number, serviceCode?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceDetailsModelOfObject>>>;
    public vasServiceGetAllServiceByParameters(serviceproviderId?: string, industryId?: string, categoryId?: number, serviceCode?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceDetailsModelOfObject>>>;
    public vasServiceGetAllServiceByParameters(serviceproviderId?: string, industryId?: string, categoryId?: number, serviceCode?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceproviderId !== undefined && serviceproviderId !== null) {
            queryParameters = queryParameters.set('serviceproviderId', <any>serviceproviderId);
        }
        if (industryId !== undefined && industryId !== null) {
            queryParameters = queryParameters.set('industryId', <any>industryId);
        }
        if (categoryId !== undefined && categoryId !== null) {
            queryParameters = queryParameters.set('categoryId', <any>categoryId);
        }
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceDetailsModelOfObject>>(`${this.basePath}/api/VasService/getallservicebyparameter`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param shortCode
     * @param keyword
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceDetailsModelOfObject>;
    public vasServiceGetByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceDetailsModelOfObject>>;
    public vasServiceGetByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceDetailsModelOfObject>>;
    public vasServiceGetByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceDetailsModelOfObject>(`${this.basePath}/api/VasService/GetByShortCodeAndKeyword`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param shortCode
     * @param network
     * @param keyword
     * @param serviceName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetExistingService(serviceProviderId?: string, shortCode?: string, network?: string, keyword?: string, serviceName?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public vasServiceGetExistingService(serviceProviderId?: string, shortCode?: string, network?: string, keyword?: string, serviceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public vasServiceGetExistingService(serviceProviderId?: string, shortCode?: string, network?: string, keyword?: string, serviceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public vasServiceGetExistingService(serviceProviderId?: string, shortCode?: string, network?: string, keyword?: string, serviceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (network !== undefined && network !== null) {
            queryParameters = queryParameters.set('network', <any>network);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/api/VasService/GetExistingService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param stringifiedGuidId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetServiceById(stringifiedGuidId?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceDetailsModelOfObject>;
    public vasServiceGetServiceById(stringifiedGuidId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceDetailsModelOfObject>>;
    public vasServiceGetServiceById(stringifiedGuidId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceDetailsModelOfObject>>;
    public vasServiceGetServiceById(stringifiedGuidId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (stringifiedGuidId !== undefined && stringifiedGuidId !== null) {
            queryParameters = queryParameters.set('stringifiedGuidId', <any>stringifiedGuidId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceDetailsModelOfObject>(`${this.basePath}/api/VasService/getservicebyid`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param shortCode
     * @param keyword
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetServiceByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<ModelSelectedDto>;
    public vasServiceGetServiceByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModelSelectedDto>>;
    public vasServiceGetServiceByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModelSelectedDto>>;
    public vasServiceGetServiceByShortCodeAndKeyword(shortCode?: string, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ModelSelectedDto>(`${this.basePath}/api/VasService/GetServiceByShortCodeAndKeyword`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param shortCde
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetServiceBySpIdAndShortcode(serviceProviderId?: string, shortCde?: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseDto>;
    public vasServiceGetServiceBySpIdAndShortcode(serviceProviderId?: string, shortCde?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseDto>>;
    public vasServiceGetServiceBySpIdAndShortcode(serviceProviderId?: string, shortCde?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseDto>>;
    public vasServiceGetServiceBySpIdAndShortcode(serviceProviderId?: string, shortCde?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (shortCde !== undefined && shortCde !== null) {
            queryParameters = queryParameters.set('shortCde', <any>shortCde);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<VasServiceResponseDto>(`${this.basePath}/api/VasService/getServiceBySpIdAndShortcode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param servicename
     * @param shortCode
     * @param keyword
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetServiceFirstOrDefault(servicename?: string, shortCode?: string, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceDetailsModelOfObject>;
    public vasServiceGetServiceFirstOrDefault(servicename?: string, shortCode?: string, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceDetailsModelOfObject>>;
    public vasServiceGetServiceFirstOrDefault(servicename?: string, shortCode?: string, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceDetailsModelOfObject>>;
    public vasServiceGetServiceFirstOrDefault(servicename?: string, shortCode?: string, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (servicename !== undefined && servicename !== null) {
            queryParameters = queryParameters.set('servicename', <any>servicename);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceDetailsModelOfObject>(`${this.basePath}/api/VasService/getservicefirstordefault`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceGetServiceProviderServiceBySpName(serviceProviderName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProviderServicesDto>>;
    public vasServiceGetServiceProviderServiceBySpName(serviceProviderName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProviderServicesDto>>>;
    public vasServiceGetServiceProviderServiceBySpName(serviceProviderName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProviderServicesDto>>>;
    public vasServiceGetServiceProviderServiceBySpName(serviceProviderName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderName !== undefined && serviceProviderName !== null) {
            queryParameters = queryParameters.set('serviceProviderName', <any>serviceProviderName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceProviderServicesDto>>(`${this.basePath}/api/VasService/GetServiceProviderServiceBySpName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param model
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceInsertService(model: CreateVasServicWithServiceTypeDetailsDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public vasServiceInsertService(model: CreateVasServicWithServiceTypeDetailsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public vasServiceInsertService(model: CreateVasServicWithServiceTypeDetailsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public vasServiceInsertService(model: CreateVasServicWithServiceTypeDetailsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling vasServiceInsertService.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/VasService/InsertService`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param model
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceUpdateServiceType(model: ServiceDetailsModelOfObject, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public vasServiceUpdateServiceType(model: ServiceDetailsModelOfObject, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public vasServiceUpdateServiceType(model: ServiceDetailsModelOfObject, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public vasServiceUpdateServiceType(model: ServiceDetailsModelOfObject, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling vasServiceUpdateServiceType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<string>(`${this.basePath}/api/VasService/updateservicecategory`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param serviceName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vasServiceValidateServiceName(serviceProviderId?: string, serviceName?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public vasServiceValidateServiceName(serviceProviderId?: string, serviceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public vasServiceValidateServiceName(serviceProviderId?: string, serviceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public vasServiceValidateServiceName(serviceProviderId?: string, serviceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/VasService/ValidateServiceName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
